import { render } from "./DayServices.vue?vue&type=template&id=d1375b80"
import script from "./DayServices.vue?vue&type=script&lang=js"
export * from "./DayServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__